import React from "react";
import AccountDetails from "../accountDetails";
import { useLocation } from "react-router-dom";

const OwnerAccountDetailsParent = () => {
    const state = useLocation()?.state
    return <AccountDetails accid={state?.id}/>;
}

export default OwnerAccountDetailsParent